import styled from 'styled-components';

export function DateInput({ keyRef, title, value, handleChange, isWithTime }: { keyRef?: string, title?: string, value: string, isWithTime?: boolean, handleChange: (value: string, keyRef?: string) => void }) {
   return (
      <Main className="dateInput">
         { title ? <h4>{ title }</h4> : null }
         <input type={isWithTime ? 'datetime-local' : 'date'} value={ value } onChange={ e => handleChange(e.target.value, keyRef) } />
      </Main>
   );
}

// ---
const Main = styled.div`
   display: flex;
   align-items: center;
   
   h4 {
      font-weight: 400;
      margin-right: 15px;
      font-size: 15px;
   }
   input {
      border-radius: 10px;
      background-color: rgb(245, 245, 245);
      border: none;
      padding: 5px 10px;
      height: 40px;
      cursor: pointer;
      font-size: 15px;
      width: 100%;
      color: #696F74;
   }
`;